import {
  Flex,
  HStack,
  Menu,
  // eslint-disable-next-line no-restricted-imports
  MenuItem,
  Text,
  Image,
  useColorMode,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuButton } from 'src/components/atoms/MenuButton';
import { Icon } from 'src/components/atoms/Icon';
import { MenuList } from 'src/components/molecules/MenuList';
import { useAuthContext } from 'src/contexts/AuthContext';
import { useThemePreference } from 'src/contexts/ThemePreferenceContext';
import { buttonClickedEvent } from 'src/libs/amp';
import { IS_DEV } from 'src/constants';

const MENU_ITEMS = {
  settings: 'Settings',
  dataConnector: 'Data Connector',
  uploadData: 'Upload Data',
  inviteNewUsers: 'Invite New Users',
  billing: 'Billing',
};

export const UserMenu: React.FC = () => {
  const { signOut } = useAuthContext();
  const { colorMode } = useColorMode();
  const { setPreference } = useThemePreference();
  const navigate = useNavigate();

  const handleThemeToggle = () => {
    setPreference(colorMode === 'dark' ? 'light' : 'dark');
  };
  const [selectedMenuItem, setSelectedMenuItem] = useState<string | null>(null);

  const handleMenuItemClick = (menuItem: string) => {
    setSelectedMenuItem(menuItem);
    if (menuItem === 'settings') {
      navigate('/settings');
    } else if (menuItem === 'uploadData') {
      navigate('/data-upload');
    }
  };

  return (
    <Flex alignItems={'center'}>
      <HStack>
        <Image
          width={10}
          height={10}
          borderRadius={8}
          src={
            'https://images.unsplash.com/photo-1619946794135-5bc917a27793?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9'
          }
        />
        <Menu>
          {({ isOpen }) => (
            <MenuButton
              px={4}
              ml={2}
              buttonName="user-menu"
              py={2}
              transition="all 0.2s"
              borderRadius="lg"
              borderWidth="1px"
              color="text.darkGray"
              fontSize="md"
              fontFamily="marketingPage"
              fontWeight="normal"
              borderColor="border.layout"
              bg="surface.control"
              _focus={{ boxShadow: 'outline' }}>
              {selectedMenuItem
                ? MENU_ITEMS[selectedMenuItem as keyof typeof MENU_ITEMS]
                : 'Manage Data'}
              {isOpen ? (
                <Icon iconName="chevron-up" color="text.title" />
              ) : (
                <Icon iconName="chevron-down" color="text.title" />
              )}
              <MenuList
                buttonName="user-menu-list"
                bg="surface.overlay"
                minW="unset"
                w="full"
                borderColor="border.layout"
                pointerEvents="all"
                borderWidth="1px"
                borderRadius="lg">
                <MenuItem
                  bg="surface.overlay"
                  onClick={() => handleMenuItemClick('settings')}>
                  <Icon mr={2} iconName="settings" />
                  <Text>Settings</Text>
                </MenuItem>
                <MenuItem
                  bg="surface.overlay"
                  onClick={() => handleMenuItemClick('uploadData')}>
                  <Icon mr={2} iconName="upload-data" />
                  <Text>Upload Data</Text>
                </MenuItem>
                {IS_DEV && (
                  <MenuItem
                    bg="surface.overlay"
                    onClick={() => handleMenuItemClick('inviteNewUsers')}>
                    <Icon mr={2} iconName="user-add" />
                    <Text>Invite New Users</Text>
                  </MenuItem>
                )}
                {IS_DEV && (
                  <MenuItem
                    bg="surface.overlay"
                    onClick={() => handleMenuItemClick('billing')}>
                    <Icon mr={2} iconName="credit-card" />
                    <Text>Billing</Text>
                  </MenuItem>
                )}
                <MenuItem bg="surface.overlay" onClick={handleThemeToggle}>
                  <Icon mr={2} iconName="display" />
                  <Text>
                    {colorMode === 'dark' ? 'Light Mode' : 'Dark Mode'}
                  </Text>
                </MenuItem>
                <MenuItem
                  bg="surface.overlay"
                  onClick={() => {
                    buttonClickedEvent({
                      buttonName: 'sign-out',
                    });
                    signOut();
                  }}>
                  <Icon mr={2} iconName="logout" />
                  <Text>Sign Out</Text>
                </MenuItem>
              </MenuList>
            </MenuButton>
          )}
        </Menu>
      </HStack>
    </Flex>
  );
};
